import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SystemRoutePath } from 'applications/GSP/shared/constants/router';

export const useSystemLinks = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        path: SystemRoutePath.PrivacyNotice,
        label: t('GSP.entities.systemLinks.privacyNotice'),
      },
      {
        path: SystemRoutePath.CookiesPolicy,
        label: t('GSP.entities.systemLinks.cookiesPolicy'),
      },
      {
        path: SystemRoutePath.TermsOfUse,
        label: t('GSP.entities.systemLinks.termsOfUse'),
      },
    ],
    [t],
  );
};
